import { Box } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { useSelector } from "react-redux";
import { CustomUserSvg } from "../../../../assets/icons/custom-svg-components/CompanySvgCollection";
import { mapToUserTypeString } from "../../../../models/enums/userType.enum";
import { AppState } from "../../../../redux";
import "./Profile.scss";
import usePermission from "../../../../services/usePermissions";
import { FavoriteStar } from "./FavoriteStar";
import { useTranslation } from "react-i18next";
import { Cart } from "./Cart";

export const Profile: React.FC = () => {
  const { t } = useTranslation(["navigationData", "snackbars"]);
  const userData = useSelector((state: AppState) => state.user.currentUser);
  const { isParticipant } = usePermission(userData?.user_type);

  const isFavoritesFeatureEnabled = useSelector(
    (state: AppState) => state.featureFlagging.featureFlags.favorite_feature_is_enabled
  );
  const IsUserSelfBookingFeatureEnabled = useSelector(
    (state: AppState) =>
      state.featureFlagging.featureFlags.user_self_booking_feature_is_enabled
  ); // TODO ML-2650

  return (
    <Box display="flex" alignItems="center">
      {isParticipant() && isFavoritesFeatureEnabled ? <FavoriteStar /> : null}
      {isParticipant() && IsUserSelfBookingFeatureEnabled ? <Cart /> : null}
      <Box mx={2} my={1}>
        <Typography>
          {userData?.user_type !== 20 ? (
            <>
              <Box component="span" className="header-profile-role-text">
                {t(mapToUserTypeString(userData?.user_type), {
                  ns: "navigationData",
                })}
              </Box>
              <br />
              <Box component="span" className="header-profile-role-name">
                {userData?.fullname}
              </Box>
            </>
          ) : (
            <Box component="span" className="header-profile-role-name">
              {userData?.fullname}
            </Box>
          )}
        </Typography>
      </Box>
      <Box mb={1} className="header-profile-role-picture">
        <CustomUserSvg />
      </Box>
    </Box>
  );
};
